// import api from '../../api'
import * as types from '../mutation-types'

// initial state
const state = {
  steps: [],
  showGuide: false,
}

// getters
const getters = {
  getGuide: state => state.steps,
  getGuideVisibility: state => state.showGuide,
}

// actions
const actions = {

  setGuideVisibility({ commit }, { visibility }){
    commit(types.SET_GUIDE_VISIBILITY, visibility)
  },
  setGuideSteps({ commit }, { steps }){
    commit(types.SET_GUIDE_OBJECT, steps)
  },

}

// mutations
const mutations = {

  [types.SET_GUIDE_VISIBILITY] (state, val ) {
    state.showGuide = val
  },

  [types.SET_GUIDE_OBJECT] (state, val) {
    state.steps = val
  },

}

export default {
  state,
  getters,
  actions,
  mutations
}
